/**
 * Profile Completion Section Component
 * Shows profile strength and completion progress
 */
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

interface ProfileCompletionSectionProps {
  completionPercentage: number;
}

export default function ProfileCompletionSection({ completionPercentage }: ProfileCompletionSectionProps) {
  return (
    <Card className="border-2 border-gray-200 shadow-xl bg-gradient-to-br from-green-50 to-emerald-50">
      <CardHeader>
        <CardTitle className="text-slate-800">Profile Strength</CardTitle>
        <CardDescription>
          Complete your profile for better matches
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex justify-between text-sm">
            <span className="text-slate-700">Completion</span>
            <span className="font-semibold text-green-600">{completionPercentage}%</span>
          </div>
          <div className="w-full bg-slate-200 rounded-full h-2">
            <div 
              className="bg-gradient-to-r from-green-500 to-emerald-500 h-2 rounded-full transition-all duration-500"
              style={{ width: `${completionPercentage}%` }}
            ></div>
          </div>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-slate-600">Photos</span>
              <span className="text-green-600">✓ Complete</span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600">Personal Info</span>
              <span className="text-amber-600">80%</span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600">Partner Preferences</span>
              <span className="text-slate-400">60%</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}